function setMatomoUserId(userId) {
  if (typeof window === 'undefined' || !userId) return;
  window._paq = window._paq || [];
  window._paq.push([
    'setUserId', String(userId) 
  ]);
}

function resetMatomoUserId() {
  if (typeof window === 'undefined') return;
  window._paq = window._paq || [];
  // clear user binding so logout traffic is not linked to the previous user
  window._paq.push([
    'resetUserId'
  ]);
}

function trackMatomoPageView() {
  if (typeof window === 'undefined') return;
  window._paq = window._paq || [];
  // send one manual pageview when we control the exact timing
  window._paq.push([
    'trackPageView'
  ]);
}

function getKeycloakUserUuid(user) {
  if (!user) return undefined;
  return user.keycloakUserUuid || user.id || undefined;
}

function setMatomoUserIdFromUser(user) {
  const userId = getKeycloakUserUuid(user);
  if (!userId) return;
  setMatomoUserId(userId);
}

export {
  setMatomoUserId,
  resetMatomoUserId,
  trackMatomoPageView,
  setMatomoUserIdFromUser
};
